import React from 'react';
// import './panel.scss';
import css from './panel.module.scss'
import {InputItem, Radio, List, Picker, DatePicker} from 'antd-mobile';
// import {createForm} from 'rc-form';
import {inject, observer} from 'mobx-react';
import {useEffect} from 'react';
import classNames from 'classnames';

const Panel = props => {
    const {className, onClose, merchant} = props;
    const {shop2} = merchant;

    useEffect(() => {
        shop2.childCategoryList = [];
        shop2.selectedCategoryId = 0;
    }, []);

    const renderChildCategoryList = list => {
        return list.map((item, i) => {
            const {id, value, active} = item;

            return (
                <Radio
                    key={id}
                    className='item'
                    checked={active}
                    onClick={e => {
                        shop2.childCategoryList[i].active = !active;
                    }}
                >
                    {value}
                </Radio>
            );
        });
    };

    return (
        <div className={classNames(css.glxMerchantAddCategoryPanel, className)}>
            {/* 一级类目 */}
            <div className={css.categoryFloor1}>
                <div className={css.titleFloor}>
                    <span className={css.title}>1级类目</span>
                </div>
                <Picker
                    title='一级类目'
                    cols={1}
                    data={shop2.categoryList.map(item => ({
                        ...item,
                        value: item.id,
                        label: item.value
                    }))}
                    value={[shop2.selectedCategoryId]}
                    onOk={value => {
                        const [selectedCategoryId] = value;

                        shop2.selectedCategoryId = selectedCategoryId;
                        shop2.fetchChildCategoryList({parentId: selectedCategoryId});
                    }}
                >
                    <List.Item>一级类目</List.Item>
                </Picker>
            </div>
            {/* 二级类目 */}
            <div className={css.categoryFloor2}>
                <div className={css.titleFloor}>
                    <span className={css.title}>二级类目</span>
                    <Radio
                        className={css.radio}
                        name='select-all-category'
                        checked={shop2.childCategoryListAllActive}
                        onClick={e => {
                            shop2.childCategoryListAllActive = !shop2.childCategoryListAllActive;
                        }}
                    >
                        全选
                    </Radio>
                </div>
                <div className={css.listFloor}>
                    {renderChildCategoryList(shop2.childCategoryList)}
                </div>
            </div>
            {/* 按钮 */}
            <div className={css.buttonContainer}>
                <div className={css.buttonFloor}>
                    <button
                        className={css.confirmBtn}
                        onClick={() => {
                            shop2.selectChildCategory({
                                parentId: shop2.selectedCategoryId,
                                childList: shop2.childCategoryList
                            });
                            onClose();
                        }}
                    >
                        确定
                    </button>
                </div>
                <div className={css.buttonFloor}>
                    <button
                        className={css.cancelBtn}
                        onClick={() => {
                            onClose();
                        }}
                    >
                        取消
                    </button>
                </div>
            </div>
        </div>
    );
};

export default inject('merchant')(observer(Panel));
